(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[122],{

/***/ 6752:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2322);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2779);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3980);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var _button_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(959);
/* harmony import */ var _button_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_button_module_scss__WEBPACK_IMPORTED_MODULE_3__);





function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var Button = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)(function(_param, ref) {
    var children = _param.children, className = _param.className, href = _param.href, _iconAlt = _param.iconAlt, iconAlt = _iconAlt === void 0 ? '' : _iconAlt, iconSrc = _param.iconSrc, _size = _param.size, size = _size === void 0 ? 'medium' : _size, theme = _param.theme, props = _objectWithoutProperties(_param, [
        "children",
        "className",
        "href",
        "iconAlt",
        "iconSrc",
        "size",
        "theme"
    ]);
    var ref1 = _slicedToArray(href ? [
        'a',
        {
            href: href
        }
    ] : [
        'button',
        {}
    ], 2), As = ref1[0], asProps = ref1[1];
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(As, _objectSpread({}, props, asProps, {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(className, _button_module_scss__WEBPACK_IMPORTED_MODULE_3__.button, _button_module_scss__WEBPACK_IMPORTED_MODULE_3__[size], _button_module_scss__WEBPACK_IMPORTED_MODULE_3__[theme]),
        ref: ref,
        children: [
            iconSrc && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                className: _button_module_scss__WEBPACK_IMPORTED_MODULE_3__.icon,
                src: iconSrc,
                alt: iconAlt
            }),
            children
        ]
    })));
});
Button.displayName = 'Button';
Button.propTypes = {
    children: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().node.isRequired),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    href: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    iconAlt: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    iconSrc: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    size: prop_types__WEBPACK_IMPORTED_MODULE_4___default().oneOf([
        'small',
        'medium',
        'large',
        'full'
    ]),
    theme: prop_types__WEBPACK_IMPORTED_MODULE_4___default().oneOf([
        'blue',
        'light',
        'midnight',
        'outline'
    ]).isRequired
};
/* harmony default export */ __webpack_exports__["Z"] = (Button);


/***/ }),

/***/ 3576:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ cta; }
});

// UNUSED EXPORTS: CTAQRCode

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(2779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(3980);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ../../node_modules/qrcode.react/lib/index.js
var lib = __webpack_require__(1498);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./src/components/buttons/button.js
var buttons_button = __webpack_require__(6752);
;// CONCATENATED MODULE: ./src/images/icons/apple.svg
/* harmony default export */ var apple = ("data:image/svg+xml;base64,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");
;// CONCATENATED MODULE: ./src/images/icons/android.svg
/* harmony default export */ var android = ("data:image/svg+xml;base64,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");
// EXTERNAL MODULE: ./src/components/buttons/cta.module.scss
var cta_module = __webpack_require__(4132);
;// CONCATENATED MODULE: ./src/components/buttons/cta.js








// This needs to be set here since it drives the rendering of the qr.
// Match the CSS for best results.
var qrSize = 74;
var CTAQRCode = function(param) {
    var keyword = param.keyword;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: cta_module.or,
                        children: "or"
                    }),
                    " text ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: keyword
                    }),
                    " to",
                    ' ',
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: "50409"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((lib_default()), {
                className: cta_module.qr,
                size: qrSize,
                bgColor: 'transparent',
                value: "smsto:50409?&body=".concat(encodeURIComponent(keyword))
            })
        ]
    }));
};
// Buttons that start a Resist.bot conversation right away
var ResistCTAButtons = function(param) {
    var className = param.className, _keyword = param.keyword, keyword = _keyword === void 0 ? 'resist' : _keyword, _theme = param.theme, theme = _theme === void 0 ? 'blue' : _theme;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()(cta_module.ctaBlock, className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(buttons_button/* default */.Z, {
                theme: theme,
                href: "https://bcrw.apple.com/sms:open?service=iMessage&recipient=urn:biz:d0189b65-f844-4344-adc1-d2d01daca04e&body=".concat(keyword),
                iconSrc: apple,
                children: "iMessage"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(buttons_button/* default */.Z, {
                theme: theme,
                href: "sms:50409?&body=".concat(keyword),
                iconSrc: android,
                children: "Text"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CTAQRCode, {
                keyword: keyword
            })
        ]
    }));
};
CTAQRCode.propTypes = {
    keyword: (prop_types_default()).string.isRequired
};
ResistCTAButtons.propTypes = {
    className: (prop_types_default()).string,
    keyword: (prop_types_default()).string,
    theme: (prop_types_default()).string
};
/* harmony default export */ var cta = (ResistCTAButtons);


/***/ }),

/***/ 6860:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "T": function() { return /* binding */ ShareBlock; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(3980);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./src/components/typography/anchor.js
var typography_anchor = __webpack_require__(8472);
// EXTERNAL MODULE: ./src/images/icons/twitter.svg
var twitter = __webpack_require__(1544);
// EXTERNAL MODULE: ./src/images/icons/facebook.svg
var facebook = __webpack_require__(7095);
;// CONCATENATED MODULE: ./src/images/icons/tumblr.svg
/* harmony default export */ var tumblr = ("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjdweCIgaGVpZ2h0PSI0OHB4IiB2aWV3Qm94PSIwIDAgMjcgNDgiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+VHVtYmxyLWJsYWNrPC90aXRsZT4KICAgIDxnIGlkPSJJY29ucyIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9IkJsYWNrIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNTExLjAwMDAwMCwgLTI2MC4wMDAwMDApIiBmaWxsPSIjMDAwMDAwIj4KICAgICAgICAgICAgPHBhdGggZD0iTTUzNS43NDA2NTgsMjk4LjM0MDczOCBDNTM0Ljg2NzEwOSwyOTguNzY2NDI1IDUzMy4xOTY1MDksMjk5LjEzNjc5NyA1MzEuOTUwNzY3LDI5OS4xNjg2NjQgQzUyOC4xODk3MDksMjk5LjI3MTQ3OCA1MjcuNDU5NzQsMjk2LjQ2OTMzNiA1MjcuNDI5NDM1LDI5NC40MzgwMDEgTDUyNy40Mjk0MzUsMjc5LjQ5NTM0NiBMNTM2Ljg2MzcwOSwyNzkuNDk1MzQ2IEw1MzYuODYzNzA5LDI3Mi4yMjczOTMgTDUyNy40NjIwOTQsMjcyLjIyNzM5MyBMNTI3LjQ2MjA5NCwyNjAgTDUyMC41ODIyNjgsMjYwIEM1MjAuNDY4OTkyLDI2MCA1MjAuMjcxMjc0LDI2MC4xMDEzMTEgNTIwLjI0MzMyMywyNjAuMzU4MzQ3IEM1MTkuODQwODI1LDI2NC4xMDA1NDkgNTE4LjEyNzI2OCwyNzAuNjY4NjQzIDUxMSwyNzMuMjk0OTE5IEw1MTEsMjc5LjQ5NTA0NiBMNTE1Ljc1NDY1LDI3OS40OTUwNDYgTDUxNS43NTQ2NSwyOTUuMTc3ODQzIEM1MTUuNzU0NjUsMzAwLjU0Nzk0IDUxOS42MzEzMzgsMzA4LjE3Njk0NSA1MjkuODY1MzExLDMwNy45OTY4NyBDNTMzLjMxODMxNywzMDcuOTM2NDQ0IDUzNy4xNTMyMjUsMzA2LjQ1OTc2NSA1MzgsMzA1LjE4NDgwNyBMNTM1Ljc0MDY1OCwyOTguMzQwNzM4IiBpZD0iVHVtYmxyIj48L3BhdGg+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=");
;// CONCATENATED MODULE: ./src/images/icons/linkedin.svg
/* harmony default export */ var linkedin = ("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iNDRweCIgaGVpZ2h0PSI0MHB4IiB2aWV3Qm94PSIwIDAgNDQgNDAiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+TGlua2VkSW4tYmxhY2s8L3RpdGxlPgogICAgPGcgaWQ9Ikljb25zIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0iQmxhY2siIHRyYW5zZm9ybT0idHJhbnNsYXRlKC03MDIuMDAwMDAwLCAtMjY1LjAwMDAwMCkiIGZpbGw9IiMwMDAwMDAiPgogICAgICAgICAgICA8cGF0aCBkPSJNNzQ2LDMwNSBMNzM2LjI3NTQsMzA1IEw3MzYuMjc1NCwyOTAuOTM4NCBDNzM2LjI3NTQsMjg3LjI1Nzc5NiA3MzQuNzU0MjMzLDI4NC43NDUxNSA3MzEuNDA5MjE5LDI4NC43NDUxNSBDNzI4Ljg1MDY1OSwyODQuNzQ1MTUgNzI3LjQyNzc5OSwyODYuNDQwNzM4IDcyNi43NjU1MjIsMjg4LjA3NDg1NCBDNzI2LjUxNzE2OCwyODguNjYxMzk1IDcyNi41NTU5NzQsMjg5LjQ3ODQ1MyA3MjYuNTU1OTc0LDI5MC4yOTU1MTEgTDcyNi41NTU5NzQsMzA1IEw3MTYuOTIxOTE5LDMwNSBDNzE2LjkyMTkxOSwzMDUgNzE3LjA0NjA5NiwyODAuMDkxMjQ3IDcxNi45MjE5MTksMjc3LjgyNzA0NyBMNzI2LjU1NTk3NCwyNzcuODI3MDQ3IEw3MjYuNTU1OTc0LDI4Mi4wOTE2MzEgQzcyNy4xMjUxMTgsMjgwLjIyNjk5NiA3MzAuMjAzNjY5LDI3Ny41NjU3OTQgNzM1LjExNjQxNiwyNzcuNTY1Nzk0IEM3NDEuMjExNDMsMjc3LjU2NTc5NCA3NDYsMjgxLjQ3NDM1NSA3NDYsMjg5Ljg5MDgyNCBMNzQ2LDMwNSBMNzQ2LDMwNSBaIE03MDcuMTc5MjEsMjc0LjQyODE4NyBMNzA3LjExNzEyMSwyNzQuNDI4MTg3IEM3MDQuMDEyNywyNzQuNDI4MTg3IDcwMiwyNzIuMzUwOTY0IDcwMiwyNjkuNzE3OTM2IEM3MDIsMjY3LjAzMzY4MSA3MDQuMDcyMjAxLDI2NSA3MDcuMjM4NzExLDI2NSBDNzEwLjQwMjYzNCwyNjUgNzEyLjM0ODA3MSwyNjcuMDI4NTU5IDcxMi40MTAxNiwyNjkuNzEwMjUyIEM3MTIuNDEwMTYsMjcyLjM0MzI4IDcxMC40MDI2MzQsMjc0LjQyODE4NyA3MDcuMTc5MjEsMjc0LjQyODE4NyBMNzA3LjE3OTIxLDI3NC40MjgxODcgTDcwNy4xNzkyMSwyNzQuNDI4MTg3IFogTTcwMy4xMDk4MzEsMjc3LjgyNzA0NyBMNzExLjY4NTc5NSwyNzcuODI3MDQ3IEw3MTEuNjg1Nzk1LDMwNSBMNzAzLjEwOTgzMSwzMDUgTDcwMy4xMDk4MzEsMjc3LjgyNzA0NyBMNzAzLjEwOTgzMSwyNzcuODI3MDQ3IFoiIGlkPSJMaW5rZWRJbiI+PC9wYXRoPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+");
;// CONCATENATED MODULE: ./src/images/icons/whatsapp.svg
/* harmony default export */ var whatsapp = ("data:image/svg+xml;base64,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");
;// CONCATENATED MODULE: ./src/images/icons/google.svg
/* harmony default export */ var google = ("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iNDhweCIgaGVpZ2h0PSI0OXB4IiB2aWV3Qm94PSIwIDAgNDggNDkiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+R29vZ2xlLWJsYWNrPC90aXRsZT4KICAgIDxnIGlkPSJJY29ucyIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9IkJsYWNrIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNDAwLjAwMDAwMCwgLTg2MC4wMDAwMDApIiBmaWxsPSIjMEIwQjBBIj4KICAgICAgICAgICAgPHBhdGggZD0iTTQyNC4zMzczODIsODc5LjY0ODUxNSBMNDI0LjMzNzM4Miw4ODkuMzUxNDg1IEM0MjQuMzM3MzgyLDg4OS4zNTE0ODUgNDMzLjY4Nzc1Niw4ODkuMzM4ODcxIDQzNy40OTQ5OSw4ODkuMzM4ODcxIEM0MzUuNDMzMyw4OTUuNjI5MDY0IDQzMi4yMjc1MTMsODk5LjA1NDQ1NSA0MjQuMzM3MzgyLDg5OS4wNTQ0NTUgQzQxNi4zNTI1NTIsODk5LjA1NDQ1NSA0MTAuMTIwNDk1LDg5Mi41MzgxODMgNDEwLjEyMDQ5NSw4ODQuNSBDNDEwLjEyMDQ5NSw4NzYuNDYxODE3IDQxNi4zNTI1NTIsODY5Ljk0NTU0NSA0MjQuMzM3MzgyLDg2OS45NDU1NDUgQzQyOC41NTkwNzQsODY5Ljk0NTU0NSA0MzEuMjg1NTg0LDg3MS40MzkzMTcgNDMzLjc4NjU1MSw4NzMuNTIxMzMyIEM0MzUuNzg4NDgxLDg3MS41MDYwMjUgNDM1LjYyMTI1Miw4NzEuMjE4ODE3IDQ0MC43MTQ1MTIsODY2LjM3Njc5MiBDNDM2LjM5MDg5Miw4NjIuNDE1MDY5IDQzMC42NDQzNzgsODYwIDQyNC4zMzczODIsODYwIEM0MTAuODk2MTU5LDg2MCA0MDAsODcwLjk2ODk2NSA0MDAsODg0LjUgQzQwMCw4OTguMDMwNzkyIDQxMC44OTYxNTksOTA5IDQyNC4zMzczODIsOTA5IEM0NDQuNDI4MjUyLDkwOSA0NDkuMzM4ODYxLDg5MS4zODkxMDkgNDQ3LjcxMDkwNyw4NzkuNjQ4NTE1IEw0MjQuMzM3MzgyLDg3OS42NDg1MTUgTDQyNC4zMzczODIsODc5LjY0ODUxNSBaIiBpZD0iR29vZ2xlIj48L3BhdGg+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=");
;// CONCATENATED MODULE: ./src/images/icons/mail.svg
/* harmony default export */ var mail = ("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjBweCIgaGVpZ2h0PSIxNnB4IiB2aWV3Qm94PSIwIDAgMjAgMTYiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+bWFpbDwvdGl0bGU+CiAgICA8ZyBpZD0iUGFnZS0xIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0ibWFpbCIgZmlsbD0iIzAwMDAwMCIgZmlsbC1ydWxlPSJub256ZXJvIj4KICAgICAgICAgICAgPHBhdGggZD0iTTE4LDE1Ljk5OTk5OTEgTDIsMTUuOTk5OTk5MSBDMC44OTU0MywxNS45OTk5OTkxIDAsMTUuMTA0NiAwLDEzLjk5OTk5OTEgTDAsMS45MTMgQzAuMDQ2NjEsMC44NDI1NSAwLjkyODUzLC0wLjAwMTAxIDIsLTkuMDYwMDcyNzFlLTA3IEwxOCwtOS4wNjAwNzI3MWUtMDcgQzE5LjEwNDYsLTkuMDYwMDcyNzFlLTA3IDIwLDAuODk1NDMgMjAsMS45OTk5OTkwOSBMMjAsMTMuOTk5OTk5MSBDMjAsMTUuMTA0NiAxOS4xMDQ2LDE1Ljk5OTk5OTEgMTgsMTUuOTk5OTk5MSBaIE0yLDMuODY4IEwyLDE0IEwxOCwxNCBMMTgsMy44NjggTDEwLDkuMiBMMiwzLjg2OCBaIE0yLjgsMiBMMTAsNi44IEwxNy4yLDIgTDIuOCwyIFoiIGlkPSJTaGFwZSI+PC9wYXRoPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+");
// EXTERNAL MODULE: ./src/siteconfig.js
var siteconfig = __webpack_require__(7082);
// EXTERNAL MODULE: ./src/components/petition/shareblock.module.scss
var shareblock_module = __webpack_require__(8967);
;// CONCATENATED MODULE: ./src/components/petition/shareblock.js












var ShareBlock = function(param) {
    var pathname = param.pathname, text = param.text;
    var fullUrl = new URL(pathname, siteconfig["default"].siteUrl).href;
    var urlSafeText = encodeURIComponent(text);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: shareblock_module.social,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(typography_anchor/* default */.Z, {
                href: "https://twitter.com/intent/tweet?url=".concat(fullUrl, "&text=").concat(urlSafeText, "&related=resistbot"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: twitter/* default */.Z,
                    alt: "Twitter"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(typography_anchor/* default */.Z, {
                href: "https://www.facebook.com/sharer.php?u=".concat(fullUrl),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: facebook/* default */.Z,
                    alt: "Facebook"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(typography_anchor/* default */.Z, {
                href: "https://www.linkedin.com/shareArticle?url=".concat(fullUrl),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: linkedin,
                    alt: "LinkedIn"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(typography_anchor/* default */.Z, {
                href: "https://api.whatsapp.com/send?phone=whatsappphonenumber&text=".concat(urlSafeText, "+").concat(fullUrl),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: whatsapp,
                    alt: "WhatsApp"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(typography_anchor/* default */.Z, {
                href: "https://www.tumblr.com/widgets/share/tool?canonicalUrl=".concat(fullUrl, "&caption=").concat(urlSafeText),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: tumblr,
                    alt: "Tumblr"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(typography_anchor/* default */.Z, {
                href: "https://mail.google.com/mail/u/0/?fs=1&to&su=&body=".concat(fullUrl, "&ui=2&tf=cm"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: google,
                    alt: "Google"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(typography_anchor/* default */.Z, {
                href: "mailto:?subject=".concat(urlSafeText, "&body=").concat(fullUrl),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: mail,
                    alt: "Email"
                })
            })
        ]
    }));
};
ShareBlock.propTypes = {
    pathname: (prop_types_default()).string.isRequired,
    text: (prop_types_default()).string.isRequired
};



/***/ }),

/***/ 959:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"button":"button_button__min1b","small":"button_small__9ZMRl","medium":"button_medium__bH1Hz","large":"button_large__UygIj","full":"button_full__ATHy_","icon":"button_icon__imq3_","blue":"button_blue__tBWUT","light":"button_light__5OWv6","midnight":"button_midnight__4HV6B","outline":"button_outline__VnTGJ"};

/***/ }),

/***/ 4132:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ctaBlock":"cta_ctaBlock__iXsYL","or":"cta_or__Oeebd","ctaHeading":"cta_ctaHeading__wWUnB","qr":"cta_qr__lJ4lF"};

/***/ }),

/***/ 8967:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"social":"shareblock_social__BzgeE"};

/***/ })

}]);